/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import Vue from 'vue';
import Vuex from 'vuex';

import assignments from './modules/assignments';
import auth from './modules/auth';
import config from './modules/config';
import groups from './modules/groups';
import notification from './modules/notification';
import org from './modules/org';
import recordings from './modules/recordings';
import user from './modules/user';
import feedback from './modules/feedback';
import invites from './modules/invites';
import responses from './modules/responses';
import wordspotting from './modules/wordspotting';
import zoom from './modules/zoom';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    assignments,
    auth,
    config,
    groups,
    notification,
    org,
    recordings,
    responses,
    user,
    feedback,
    invites,
    wordspotting,
    zoom,
  },
  strict: process.env.NODE_ENV !== 'production'
});

setInterval(() => {
  store.dispatch('pollRecordings');
}, 10000);

export default store;
